import { useState, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { findMatchingMenuItem } from '../lib/find-matching-menu-item';

import type { MainMenuItem } from '../side-menu-interfaces';

type ExpandedMenuState = Partial<Record<string, boolean>>;

export const useExpandedMenuState = (location: ReturnType<typeof useLocation>, menuItems: MainMenuItem[]) => {
  const [expandedMenuState, setExpandedMenuState] = useState<ExpandedMenuState>({});

  const toggleMenuItem = useCallback((menuItem: MainMenuItem) => {
    const menuTitle = menuItem.menuTitle;

    setExpandedMenuState(prevState => {
      return prevState[menuTitle] ? {} : { [menuTitle]: true };
    });
  }, []);

  const syncExpandedStateWithLocation = useCallback(() => {
    const matchingMenuItem = findMatchingMenuItem(menuItems, location);

    if (matchingMenuItem) {
      setExpandedMenuState({
        [matchingMenuItem.menuTitle]: true
      });
    }
  }, [location, menuItems]);

  return {
    expandedMenuState,
    toggleMenuItem,
    syncExpandedStateWithLocation
  };
};
